// src/shared/utils/searchUtils.ts
export function sanitizeSearchInput(input: string): string {
  // Example sanitization: trim, remove special chars, collapse spaces
  return input.replace(/[^\w\s@+.-]/g, "").replace(/\s+/g, " ").trim();
}
